import { render, staticRenderFns } from "./documentBlock.vue?vue&type=template&id=91a119e4"
import script from "./documentBlock.vue?vue&type=script&lang=js"
export * from "./documentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports